/**
 * CommandCentre Component
 *
 * Home dashboard with quick actions, attention needed items,
 * today's snapshot, and weekly performance charts.
 */

import { useState, useEffect } from 'react'
import { PageLayout } from '../layout'
import TodaySnapshot from './TodaySnapshot'
import MonthlySalesChart from './MonthlySalesChart'
import WeeklyPerformance from './WeeklyPerformance'
import DailyEnergyChart from './DailyEnergyChart'
import { fetchFarmInformation, getFarmLogoUrl } from '../../supabase-client'

export default function CommandCentre({ user, onLogout }) {
  const [logoUrl, setLogoUrl] = useState(null)

  useEffect(() => {
    fetchFarmInformation()
      .then(info => {
        if (info?.logo_file_path) {
          setLogoUrl(getFarmLogoUrl(info.logo_file_path))
        }
      })
      .catch(() => {})
  }, [])

  return (
    <PageLayout
      user={user}
      onLogout={onLogout}
      showFooter={true}
    >
      <div className="h-full overflow-y-auto">
      <div className="space-y-6">
        {/* Farm Logo */}
        {logoUrl && (
          <div className="flex justify-center pt-2 pb-[40px] px-[40px]">
            <img src={logoUrl} alt="Farm logo" className="max-h-30 object-contain" />
          </div>
        )}

        {/* Today's Snapshot + Monthly Sales Comparison */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <TodaySnapshot />
          <MonthlySalesChart />
        </div>

        {/* Weekly Performance */}
        <WeeklyPerformance />

        {/* Daily Energy */}
        <DailyEnergyChart />
      </div>
      </div>
    </PageLayout>
  )
}
